<template>
  <div></div>
</template>

<script>
import { getInfoByCode } from '../../api/api'

const LABEL_CN = 72
const LABEL_GLOBAL = 73

export default {
  name: 'AstaxinEntry',
  data() {
    return {
      code: ''
    }
  },
  async mounted() {
    const raw = this.$route.query.c
    if (!raw) {
      alert('码不正确')
      return
    }
    this.code = String(raw)

    try {
      const res = await getInfoByCode(this.code)
      if (res.data.code !== '200' || !res.data.data) {
        alert('获取产品信息失败')
        return
      }
      const labelId = Number(res.data.data.labelId)
      if (labelId === LABEL_GLOBAL) {
        // 国外页保持手输，不带 c
        this.$router.replace({ path: '/astaxin' })
      } else if (labelId === LABEL_CN) {
        // 国内仍走扫码页（与现有 domain 配置一致），由用户输入/扫码后再进结果页
        this.$router.replace({ path: '/astaxin/scan' })
      } else {
        alert('未识别的标签类型')
      }
    } catch (e) {
      alert('获取产品信息失败')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Astaxin/Entry.vue